import React from 'react'
import { createRoot } from 'react-dom/client'
import { createBrowserRouter, RouterProvider, Outlet } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from 'react-query'

import '../css/reset.css'
import '../css/main.css'
import './login.css'

import Container from './Container/Container'

import GenericError from './GenericError/GenericError'
import Login from './Login/Login'
import InvalidSignupError from './InvalidSignupError/InvalidSignupError'
import SignUp from './Signup/SignUp'
import PasswordReset from './PasswordReset/PasswordReset'
import ForgotPassword from './ForgotPassword/ForgotPassword'
import PaymentLink from './PaymentLink/PaymentLink'
import PaymentComplete from './PaymentComplete/PaymentComplete'
import PrivacyPolicyPage from 'shared/PrivacyPolicyPage/PrivacyPolicyPage'

const queryClient = new QueryClient()

export const App: React.FC = (): React.ReactElement => {
  return <Outlet />
}

const PrivacyPolicy = () => (
  <Container width="80%">
    <PrivacyPolicyPage />
  </Container>
)

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    errorElement: <GenericError />,
    children: [
      { path: '/', element: <Login /> },
      { path: '/change-password', element: <PasswordReset /> },
      { path: '/sign-up', element: <SignUp /> },
      { path: '/invalid-sign-up', element: <InvalidSignupError /> },
      { path: '/forgot-password', element: <ForgotPassword /> },
      { path: '/pay', element: <PaymentLink /> },
      { path: '/payment-complete', element: <PaymentComplete /> },
      { path: '/privacy', element: <PrivacyPolicy /> },
    ],
  },
])

export const AppRouter: React.FC = (): React.ReactElement => {
  return (
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router}></RouterProvider>
      </QueryClientProvider>
    </React.StrictMode>
  )
}

const container = document.getElementById('app')!
const root = createRoot(container)
root.render(<AppRouter />)
